import React, {useEffect, useState} from "react";
import {Link} from "react-router-dom";
import {useDispatch, useSelector} from 'react-redux';
import {getCurrencySymbol} from "./utils/currency";
import Pie from "./PiePortfolioSVG";
import Box from '@material-ui/core/Box';
import {Grid, Typography} from "@material-ui/core";
import {Container} from "@material-ui/core";
import ChartPortfolio from "./ChartPortfolio";
import {makeStyles} from "@material-ui/core/styles";
import _ from "lodash";
import PiePortfolio from "./PiePortfolioSVG";
import TransactionAddDialog from "./TransactionAddDialog";
import Hidden from "@material-ui/core/Hidden";
import EmptyPortfolio from "./EmptyPortfolio";
import CorporateActions from "./CorporateActions"
import CorporateActionsTable from "./CorporateActionsTable"
const useStyles = makeStyles((theme) =>({
    root: {
        minWidth: 275,
        flex: 1,
        paddingLeft: 104,
        color: theme.palette.background.paper,
    },
    pie: {
        flex: 1,
        maxWidth: 374,
        height: 374,
        background: theme.palette.background.paper,
        marginTop: 32,
        marginRight: 32,
        padding: 35,
        borderRadius: 16,
        border: `1px solid ${theme.palette.grey[200] || '#E8ECF2'}`,
    },
    chart: {
        flex: 1,
        height: 374,
        background: theme.palette.background.paper,
        padding: 35,
        marginTop: 32,
        borderRadius: 16,
        border: `1px solid ${theme.palette.grey[200] || '#E8ECF2'}`,
        [theme.breakpoints.down('sm')]: {
            padding: 10,
        },
    },
    details: {
        marginTop: 32,
    },
    bullet: {
        display: 'inline-block',
        margin: '0 2px',
        transform: 'scale(0.8)',
    },
    title: {
        fontSize: 20,
    },
    pos: {
        marginBottom: 12,
    },
    dashboard: {
        background: theme.palette.primary.main,
        minHeight: 164,
        borderRadius: 16,
    }
}));
export default function (){
    window.scrollTo(0, 0);
    const dispatch = useDispatch();
    //const [data, setData] = useState(undefined);
    const portfolioList = useSelector(store => store.portfolios?.list);
    const selectedIndex = useSelector(store => store.user.portfolio);
    const data = useSelector(store => store.portfolio?.data)
    const portfolio = portfolioList[selectedIndex] || undefined
    const classes = useStyles();
    if (_.isEmpty(data?.transactions) ){
        return (
            <div style={{display: 'flex', justifyContent: 'center', marginTop: '20%'}}>
                <div >
                    <Typography style={{textAlign: 'center'}} variant="h4" gutterBottom>Сделок пока нет</Typography><br/>
                    <EmptyPortfolio/>
                </div>
            </div>
        )
    }

    return (
        <Container style={{marginTop: 30, marginBottom: 120}}>
            <Hidden mdUp>
                <Grid container
                      alignItems="center"
                      justifyContent="center"
                      component={Box} className={classes.chart}>
                    <PiePortfolio
                        xs={12}
                        portfolio={data}
                        currency={getCurrencySymbol(data?.portfolio?.currency) || ''}
                    />
                </Grid>
            </Hidden>


            <Box className={classes.chart}>
                <Typography variant="h5" component="h2">
                    Прибыль
                </Typography>
                <ChartPortfolio
                    data ={_.map(data?.graph, 'if')}
                    category ={_.map(data?.graph, 'd')}
                    series_title ={''}
                    currency = {getCurrencySymbol(data?.portfolio?.currency) || ''}
                />
            </Box>
            <Box className={classes.chart}>
                <Typography variant="h5" component="h2">
                    Средняя годовая доходность (AAR)
                </Typography>
                <ChartPortfolio
                    data ={_.map(data?.graph, 'aar')}
                    category ={_.map(data?.graph, 'd')}
                    series_title ={'AAR'}
                    currency = {'%'}
                />
            </Box>

        </Container>
    )
}